import { aiTeamRatingAltActivePageQuery } from '@lib/sanity/queries';
import AiTeamRatingFunnel, {
  createAiTeamRatingStaticProps
} from '@components/quiz/AiTeamRatingFunnel';

/**
 * FFH-1744 — the alt-pricing arm of the AI Team Rating funnel.
 *
 * Identical to /ai-team-rating in every respect except which settings singleton
 * it reads: this one follows `aiTeamRatingSettingsAlt`, whose page carries the
 * higher-priced tier cards. Nothing about the price lives in this file, or in
 * the shared component — it comes from the Sanity document's tier cards.
 *
 * To stop the test, repoint that singleton at the control funnel page in the
 * Studio; this URL then serves normal pricing within ~60s and no deploy is
 * needed. See `aiTeamRatingAltActivePageQuery` for why its fallback is the
 * control page.
 */
export const getStaticProps = createAiTeamRatingStaticProps(
  aiTeamRatingAltActivePageQuery
);

export default AiTeamRatingFunnel;
